import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify'; // Assuming react-toastify is installed and configured
import { BASE_URL } from '../../api/ApiConfig'; // Assuming BASE_URL is imported similarly to ROOT_URL

export const getAllKbCategories = createAsyncThunk(
  'kbCategory/getAllKbCategories',
  async ({ group_id } = {}, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id = loginToken?.response?.user?.business_id;

      if (!group_id) {
        return rejectWithValue({ message: 'Missing group_id' });
      }

      const response = await axios.get(
        `${BASE_URL}/trustchat-backend-service/v1/kb/categories/${business_id}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          },
          params: { group_id }
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: true,
  error: null,
  success: false,
  data: null,
  lastFetchedGroupId: null,
  activeRequestId: null,
};

const getAllKbCategoriesSlice = createSlice({
  name: 'getAllKbCategories',
  initialState,
  reducers: {
    resetGetAllKbCategoriesState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
      state.lastFetchedGroupId = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllKbCategories.pending, (state, action) => {
        state.activeRequestId = action.meta.requestId;
        const groupId = action.meta?.arg?.group_id ?? null;
        const sameGroup =
          state.lastFetchedGroupId != null &&
          String(state.lastFetchedGroupId) === String(groupId);
        state.loading = !sameGroup || !state.data;
        state.error = null;
        if (!state.data) {
          state.success = false;
        }
      })
      .addCase(getAllKbCategories.fulfilled, (state, action) => {
        if (state.activeRequestId && action.meta.requestId !== state.activeRequestId) {
          return;
        }
        state.loading = false;
        state.success = true;
        state.data = action.payload;
        state.lastFetchedGroupId = action.meta?.arg?.group_id ?? null;
      })
      .addCase(getAllKbCategories.rejected, (state, action) => {
        if (state.activeRequestId && action.meta.requestId !== state.activeRequestId) {
          return;
        }
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        if (action.payload?.message !== 'Missing group_id') {
          toast.error(action.payload?.message || 'Failed to fetch categories.');
        }
      });
  }
});

export const { resetGetAllKbCategoriesState } = getAllKbCategoriesSlice.actions;
export default getAllKbCategoriesSlice.reducer;